export interface Vet {
    id: number;
    name: string;
    specialty: string;
    rating: number;
    reviews: number;
    image: string;
}

export const expertVets: Vet[] = [
    { id: 1, name: "Dr. Sarah Mitchell", specialty: "Senior Surgeon", rating: 4.9, reviews: 124, image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?auto=format&fit=crop&w=200&q=80" },
    { id: 2, name: "Dr. James Wilson", specialty: "Dermatologist", rating: 4.8, reviews: 210, image: "https://images.unsplash.com/photo-1622253692010-333f2da6031d?auto=format&fit=crop&w=200&q=80" },
    { id: 3, name: "Dr. Elena Rodriguez", specialty: "Exotic Specialist", rating: 5.0, reviews: 86, image: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?auto=format&fit=crop&w=200&q=80" },
];
